import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { EditorActions } from '@atlaskit/editor-core';

export const updateNodeParameters = (editorActions: EditorActions, updatedParameters: any) => {
	const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();

	const updatedNodeSelection = {
		...selectedNodeJSON,
		attrs: {
			...selectedNodeJSON?.attrs,
			parameters: { ...updatedParameters },
		},
	};

	editorActions.replaceSelection(updatedNodeSelection, true);
};

export const replaceSelectedNode = (editorActions: EditorActions, nodeAdf: ADFEntity) => {
	editorActions.replaceSelection(nodeAdf, true);
};
